// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"456a199c","150":"100e34f5","453":"db40268f","472":"bef8959f"}[chunkId] + ".chunk.js";
};